import React from "react";
import { Link, useLocation } from "react-router-dom";

const ServicesSidebar = ({ service }) => {
  const location = useLocation();
  const isActive = location.pathname === `/services/${service?.id}`;

  return (
    <ul>
      
        <Link to={`/services/${service?.id}`}>
        <li className={`border border-l-4 px-4 py-4 text-1xl font-Roboto transition-all duration-300 ${isActive ? 'bg-primary text-white' : 'border-primary hover:bg-secondary hover:text-white'}`}>
          {service?.title}
      </li>
        </Link>
    </ul>
  );
};

export default ServicesSidebar;
